import { jobSectionMap } from '../redux/jobSectionMap';
import { readFullJobTbdAudit } from '../redux/fullJobTbdAudit';

// Shared-hook editors have draft/save reporting. Audited display-only sections
// and guarded custom editors can also refresh during editable job sessions.
export const editableJobSections = new Set([
  'generalProject', 'generalStation', 'soldToShipTo', 'priceBreakdown', 'ownersManual',
  'hcRequirements', 'skidConstruction', 'pumpManifoldPiping', 'stationEnclosure',
  'dropPipeComments', 'dropPipes', 'levelControls', 'fillSources', 'pumps', 'pumpDetails',
  'waterTreatment', 'inletScreen', 'inletStrainer', 'dischargeStrainer', 'dischargeFilter',
  'roSystem', 'uvSystem', 'fertigation', 'skyHarvester', 'shipLoose', 'unregulatedPower',
  'unregulatedBreakers', 'regulatedPower', 'regulatedBreakers', 'sequenceOfOperations',
  'electricalOptions', 'telemetry', 'telemetryAccessories', 'controlLogicOnly',
  'selectedPumpOptionList', 'customOptions', 'warningReport', 'changedOptions',
  'shipEarlyParent', 'shipEarlyItems',
  'changeOrderParent', 'changeOrderDetails',
]);
const routes = ['general-project-info', 'general-station-info', 'soldto-shipto-info', 'price-breakdown-info',
  'owners-manual-info', 'hc-requirements', 'skid-construction', 'pump-manifold-piping', 'station-enclosure',
  'drop-pipe-comments', 'drop-pipes', 'level-controls', 'fill-sources', 'pump-parent', 'pump-details',
  'water-treatment-toggles', 'inlet-screen', 'inlet-strainer', 'discharge-strainer', 'discharge-filter',
  'ro-system', 'uv-system', 'fertigation', 'sky-harvester', 'ship-loose', 'unregulated-power-supply',
  'unregulated-breakers', 'regulated-power-supply', 'regulated-breakers', 'sequence-of-operations',
  'electrical-options', 'telemetry', 'telemetry-accessories', 'selected-pump-option-list', 'custom-options',
  'warning-report', 'changed-options', 'control-logic-only', 'ship-early-parent', 'ship-early-items',
  'change-order-parent', 'change-order-details'];
export const jobResources = ['portal:full-job', ...routes.map(route => `portal:${route}`)];

export function readJobSnapshot(payload, jobId, editable = false) {
  const core = payload?.[String(jobId)] || payload;
  if (!core || typeof core !== 'object' || Array.isArray(core)) return null;
  const project = Array.isArray(core.GeneralProjectInfo) ? core.GeneralProjectInfo : [core.GeneralProjectInfo];
  if (project.length !== 1 || String(project[0]?.ID) !== String(jobId)) return null;
  const result = {};
  for (const [apiKey, section] of Object.entries(jobSectionMap)) {
    if (editable && !editableJobSections.has(section)) continue;
    // Omitted fields are not proof of deletion; explicit [] is.
    if (!Object.prototype.hasOwnProperty.call(core, apiKey)) continue;
    const value = core[apiKey];
    if (value === null || typeof value !== 'object') return null;
    const rows = Array.isArray(value) ? value : [value];
    if (rows.some(row => !row || Array.isArray(row) || typeof row !== 'object')) return null;
    if (rows.some(row => row.ProjectID != null && String(row.ProjectID) !== String(jobId))) return null;
    result[section] = rows;
  }
  if (Object.prototype.hasOwnProperty.call(core, 'TBDAudit')) {
    if (!Array.isArray(core.TBDAudit) || core.TBDAudit.some(row => !row || typeof row !== 'object' || Array.isArray(row) || (row.ProjectID != null && String(row.ProjectID) !== String(jobId)))) return null;
    result.tbdAudit = readFullJobTbdAudit(core);
  }
  return result;
}
